import { useState } from 'react';
import { Flex, Modal } from 'components';
import { StageYear, StageDefault, StageMonth } from './components';
import './style.scss';

type Stage = 'loading' | 'date' | 'month' | 'year';

interface IProps {
  onClose?: () => void;
  onSelect?: (date: Date) => void;
  date?: Date | null;
}

function ModalCalendar(props: IProps) {
  const date = props.date ?? new Date();

  const [stage, setStage] = useState<Stage>('date');
  const [day, setDay] = useState<number>(date.getDate());
  const [monthIndex, setMonthIndex] = useState<number>(date.getMonth());
  const [year, setYear] = useState<number>(date.getFullYear());

  const updateDate = (year: number, month: number, day: number) => {
    setYear(year);
    setMonthIndex(month);
    setDay(day);
    setStage('date');
  };

  const handleDayClick = (selectedDate: number) => {
    const date = new Date(year, monthIndex, selectedDate);
    props.onSelect?.(date);
  };

  return (
    <Modal
      size={400}
      onClose={props.onClose}
      header='Календарь'
    >
      <Flex
        justifyContent='center'
        className='calendar-fl-oiWf'
      >
        {stage === 'date' && (
          <StageDefault
            day={day}
            month={monthIndex}
            year={year}
            onMonthClick={() => setStage('month')}
            onYearClick={() => setStage('year')}
            onDayClick={handleDayClick}
          />
        )}
        {stage === 'month' && (
          <StageMonth
            month={monthIndex}
            onAccept={(month) => updateDate(year, month, day)}
          />
        )}
        {stage === 'year' && (
          <StageYear
            year={year}
            onAccept={(year) => updateDate(year, monthIndex, day)}
          />
        )}
      </Flex>
    </Modal>
  );
}

export default ModalCalendar;
